import { CartResponse, CheckoutResponse } from '@/types/cart'
import { api } from './api'

export const getCart = (): Promise<CartResponse> => api.get('/cart')

export const clearCart = () => api.delete('/cart')

export const addToCart = (id: string) => api.post(`/cart/${id}`)

export const deleteFromCart = (recommendationProductId: string) =>
  api.delete(`/cart/${recommendationProductId}`)

export const getCartCount = () => api.get(`/cart/getCartCount`)

export const submitCheckout = ({
  paymentId,
  items,
}: {
  paymentId: string
  items: any
}): Promise<CheckoutResponse> =>
  api.post(`/cart/checkout`, { paymentId, items })
